// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"8a9045f6","427":"e0d378bf","431":"88596bdc","473":"8246f0a2","480":"24c99931","563":"be807a8e","645":"59225473","774":"9a66cf51","790":"ae0c7206"}[chunkId] + ".chunk.css";
};